import { apiClient } from "../api";

/**
 * Servicio de preguntas (CRUD)
 */

export const getPreguntas = async ({ idCurso } = {}) => {
  const { data } = await apiClient.get("preguntas", {
    params: idCurso ? { idCurso } : undefined,
  });
  return data;
};

export const createPregunta = async (payload) => {
  const { data } = await apiClient.post("preguntas", payload);
  return data;
};

export const updatePregunta = async (idPregunta, payload) => {
  const { data } = await apiClient.put(
    `preguntas/update/${idPregunta}`,
    payload
  );
  return data;
};

export const deletePregunta = async (idPregunta) => {
  const { data } = await apiClient.delete(`preguntas/${idPregunta}`);
  return data;
};
